import { ErrorCode } from 'react-dropzone';
import { CustomFileErrorCode } from './types';
export const genFileUID = (fileName) => {
    const timestamp = Date.now();
    return `GENERATED-${timestamp}-${fileName}`;
};
export const formatErrorMessage = (errorCode, maxSize) => {
    var _a, _b;
    switch (errorCode) {
        case ErrorCode.FileTooLarge:
            return `File size is too large (${(_b = (_a = formatFileSize(maxSize)) !== null && _a !== void 0 ? _a : maxSize) !== null && _b !== void 0 ? _b : 'MB'} max.)`;
        case CustomFileErrorCode.NetworkError:
            return 'Sorry, something went wrong. Please try again later.';
        case CustomFileErrorCode.FileNonUniqueName:
            return 'File with this name already exists';
        case ErrorCode.FileInvalidType:
            return 'Invalid file format.';
        case ErrorCode.TooManyFiles:
            return 'Too many files.';
        default:
            return 'Sorry, something went wrong. Please try again later.';
    }
};
export function formatFileSize(fileSize) {
    if (!fileSize)
        return null;
    if (fileSize === 0) {
        return '0 bytes';
    }
    const units = ['bytes', 'Kb', 'Mb', 'Gb', 'Tb'];
    const base = 1024;
    let index = 0;
    while (fileSize >= base && index < units.length - 1) {
        fileSize /= base;
        index++;
    }
    const unitName = units[index];
    return `${fileSize.toFixed(2)} ${unitName}`;
}
export const filesValidator = (allFiles) => (checkFile) => {
    const hasDuplicateName = allFiles.some((file) => file.name === checkFile.name);
    if (hasDuplicateName) {
        return {
            message: 'File with this name exists',
            code: CustomFileErrorCode.FileNonUniqueName
        };
    }
    else if (!checkFile.size || !checkFile.type) {
        return {
            message: 'Invalid file format',
            code: ErrorCode.FileInvalidType
        };
    }
    return null;
};
export const converFileToExtended = (file) => {
    return {
        uid: genFileUID(file.name),
        lastModified: file.lastModified,
        name: file.name,
        uploadStatus: null,
        size: file.size,
        originalFile: file
    };
};
export const updateFilesStatus = (uploadStatus, fileNamesToUpdate, oldFiles) => {
    return oldFiles.map((file) => {
        if (fileNamesToUpdate.includes(file.name)) {
            if (file.uploadStatus === 'error' && uploadStatus !== 'error') {
                delete file.errors;
            }
            file.uploadStatus = uploadStatus;
        }
        return file;
    });
};
export const isValidUrl = (url) => {
    try {
        new URL(url);
        return true;
    }
    catch (error) {
        return false;
    }
};
export const urlToBlob = async (url, customFetch = fetch) => {
    try {
        const response = await customFetch(url);
        const blob = await response.blob();
        return blob;
    }
    catch (error) {
        return new Error('Error in fetching URL');
    }
};
